import styled from "styled-components"

import Label from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { Color, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"
import { Event } from "~/entities/Event"
import { EventSchedule } from "~/entities/EventSchedule"
import { ShortInternshipSchedule } from "~/entities/ShortInternshipSchdule"

interface Props {
  event?: Event
  schedule: ShortInternshipSchedule | EventSchedule
  externalApplication: boolean
  applicationUrl?: string
}

const EntryNumbers = ({ numberOfApplications, capacity }: { numberOfApplications: number; capacity: number }) => {
  if (numberOfApplications < capacity * 0.8) {
    return <StyledCapacity>定員{capacity}名</StyledCapacity>
  }
  return (
    <>
      <StyledEntryNum>{numberOfApplications}名</StyledEntryNum>
      <StyledCapacity>/定員{capacity}名</StyledCapacity>
    </>
  )
}

const SchduleCard = ({ event, schedule }: Props) => {
  return (
    <StyledSchduleCardWrapper>
      <StyledLeftArea>
        <StyledDate type="SubHeading">
          {schedule.startsOn && schedule.endsOn ? (
            <span>
              {schedule.startsOn}〜{schedule.endsOn}
            </span>
          ) : (
            <span>{schedule.scheduleNote}</span>
          )}
        </StyledDate>
        <StyledPlace>{schedule.place}</StyledPlace>
        <StyledAddress>{schedule.address}</StyledAddress>
        <StyledDeadline>
          {schedule.entryDeadline !== "募集終了" && "締切："}
          {schedule.entryDeadline ? <span>{schedule.entryDeadline}</span> : <span>{schedule.entryDeadlineNote}</span>}
        </StyledDeadline>
      </StyledLeftArea>
      {event && (
        <StyledCapacityWrapper>
          <EntryNumbers numberOfApplications={schedule.numberOfApplications} capacity={schedule.capacity} />
          {schedule.beforeEntryDeadline ? (
            <StyledLabel size="Small" color={Color.Attention}>
              {event.selectsByLottery ? "抽選" : "先着"}
            </StyledLabel>
          ) : (
            <StyledLabel size="Small" color={Color.LightGray}>
              締切
            </StyledLabel>
          )}
        </StyledCapacityWrapper>
      )}
    </StyledSchduleCardWrapper>
  )
}

const StyledSchduleCardWrapper = styled.div`
  padding: ${SpacingSize.M}px;
  display: flex;
  justify-content: space-between;
  border-radius: ${RadiusSize.Medium}px;
  background-color: ${Color.BackgroundGray};
  overflow: hidden;
  &:not(:last-child) {
    margin-bottom: ${SpacingSize.XS}px;
  }
`

const StyledLeftArea = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
`

const StyledDate = styled(Typography)`
  margin-bottom: ${SpacingSize.XS}px;
  color: ${Color.Black};
`

const StyledPlace = styled.div`
  margin-bottom: ${SpacingSize["4XS"]}px;
  font-size: ${TextSize.S}px;
  font-weight: bold;
  color: ${Color.Gray};
  line-height: ${LineHeight["2XS"]}%;
`

const StyledAddress = styled.div`
  margin-bottom: ${SpacingSize.XS}px;
  font-size: ${TextSize.S}px;
  color: ${Color.Gray};
  line-height: ${LineHeight.M}%;
`

const StyledDeadline = styled.div`
  font-size: ${TextSize.XS}px;
  font-weight: bold;
  color: ${Color.Attention};
`

const StyledCapacityWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`

const StyledEntryNum = styled.span`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.XL}px;
  font-weight: bold;
`

const StyledCapacity = styled.span`
  margin-bottom: 6px;
  font-size: ${TextSize.XS}px;
  color: ${Color.Gray};
`

const StyledLabel = styled(Label)`
  width: 80px;
  bottom: 8.5px;
  left: 16px;
`

export default SchduleCard
